<template>
  <div layout="column center-center" class="w100" @click="click(city)">
    <div class="container" layout="column top-left">
      <digit-v v-for="n in digits" :active="isActive(n)"/>
    </div>
    <div class="city">{{city.name}}</div>
  </div>

</template>

<script>
  import DigitV from "./DigitV";
  import Rnd from "@/Rnd";

  export default {
    components: {DigitV},
    props: ['city', 'maxScore'],
    name: "score-bar-h",
    data() {
      return {
        digits: 50,
        loaded: false
      }
    },
    mounted() {
      this.loaded = true;
    },
    methods: {
      isActive: function (index) {

        const cityScore = this.city.scores.score;
        const scorePerDigit = Math.round(this.maxScore / this.digits);
        const cityDigits = this.digits + 1 - Math.round(cityScore / scorePerDigit);
        console.log('v', index > cityDigits);
        return (index > cityDigits);
      },
      click(city) {
        this.$router.push(`/${city.key}`);
      }
    }
  }
</script>

<style scoped>
  .container {
    width: 30px;
  }

  .city {
    transform: rotate(90deg);
    margin-top: 0.5rem;
    width: 10px;
    font-weight: 200;
    /*transform-origin: left center;*/
  }
</style>



// WEBPACK FOOTER //
// src/components/blocks/ScoreBarV.vue